/**
 * Dashboard - Add and manage upload images on forms
 */

'use strict';

var FrontDashboardFormImages = function () {};

FrontDashboardFormImages.prototype = {
    lockAjaxForm: false,

    /**
     * Handle the "+" button to add more input fields.
     * 
     * @param {number} maxImages    Maximum allowed images
     * @param {boolean} isUpdate    Does this method is called from a create or edit screen?
     */
    addImages: function(maxImages, isUpdate) {
        // Dynamically add input fields when the user click on the "+" button

        $('#images .btn-add').on('click', function() {
            var nbFields = parseInt($('#images .files-fields .file-field').length);

            if (isUpdate) {
                nbFields = parseInt($('#images .row-images:not(.row-images-preview) .col-image').length) + nbFields;
            }

            if (nbFields >= maxImages) {
                return;
            }

            var field = '<div class="file-field input-field col s12">' +
                '<div class="btn btn-small dark z-depth-0">' +
                '<span>' + comedien.i18n.uploadBrowserFile + '</span>' +
                '<input type="file" id="image-' + (nbFields + 1) + '" name="images[]" accept="image/gif, image/jpeg, image/png" />' +
                '</div>' +
                '<div class="file-path-wrapper"><input class="file-path validate" type="text" placeholder="' + comedien.i18n.uploadImage + ' ' + (nbFields + 1) + '"></div>' +
                '</div>';

            $('#images .files-fields').append(field);

            if (nbFields == (maxImages - 1)) {
                $('#images .col-add').hide();
            }
        });

        if (isUpdate) {
            var nbImages = parseInt($('#images .row-images .col-image').length);

            if (nbImages > 0) {
                $('#images .files-fields .file-path').attr('placeholder', comedien.i18n.uploadImage + ' ' + (nbImages + 1));
            }

            if (nbImages == (maxImages - 1)) {
                $('#images .col-add').hide();
            }
        }

        // Show thumbnail preview before upload

        $('#images .files-fields').on('change', 'input[type="file"]', function() {
            var id = $(this).attr('id');

            if (this.files && this.files[0]) {
                var reader = new FileReader();

                reader.onload = (function(theFile) {
                    return function(e) {
                        // Render thumbnail
                        $('#images .col-preview').show();

                        var $preview = $('#images #preview-' + id);

                        if ($preview.length > 0) {
                            // Preview already exist fot this input field
                            // Replace the thumbnail

                            $preview.find('img').attr('src', e.target.result);
                            $preview.find('img').attr('title', encodeURI(theFile.name));
                        } else {
                            // Create a preview for this input field

                            var preview = '<div id="preview-' + id + '" class="col s4 col-image ui-state-default">' +
                                '<div class="inner"><img src="' + e.target.result + '" alt="" title="' + encodeURI(theFile.name) + '" /></div>' +
                                '</div>';

                            $('#images .col-preview .row-images').append(preview);
                        }
                    };
                })(this.files[0]);

                reader.readAsDataURL(this.files[0]);
            } else {
                var nbPreviews = parseInt($('#images .col-preview .row-images .col-image').length);

                var $preview = $('#images #preview-' + id);
                if ($preview.length > 0) {
                    $preview.remove();

                    if (nbPreviews == 1) {
                        $('#images .col-preview').hide();
                    }
                }
            }
        });
    },

    /**
     * Allows user to manage the event's images by:
     * - removing an image
     * - moving an image (drag'n'drop with jQuery UI)
     */
    manageImages: function() {
        var self = this;
        var idPost = parseInt($('#idPostEdited').val());
        var idAttachment = 0;

        // jQuery UI Sortable
        $('section#images .row-images').sortable();

        // Display action buttons on hover
        $('section#images .row-images .col-image').mouseover(function() {
            $(this).find('.actions').removeClass('hidden');
        }).mouseout(function() {
            $(this).find('.actions').addClass("hidden");
        });

        // Delete image

        $('section#images .row-images .delete').on('click', function(e) {
            e.preventDefault();

            var container = $(this).parents('.col-image');
            container.hide(250, function() {
                container.remove();
            });
        });

        // Manage copyright

        var $modalCopyright = $('#modal-dashboard-media-copyright');

        $('section#images .row-images .copyright').on('click', function(e) {
            e.preventDefault();

            idAttachment = parseInt($(this).closest('.col-image').attr('data-attachment-id'));

            if (idPost > 0 && idAttachment > 0) {
                // Get the current copyright for this media

                if (self.lockAjaxForm) {
                    // Pending AJAX request... wait
                    return;
                }

                self.lockAjaxForm = true;

                M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');

                var ajaxAction = 'dashboard.media.get_copyright';

                $.ajax({
                    url: comedien.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: "action=" + ajaxAction + "&security=" + comedien.security + "&idPost=" + idPost + "&idAttachment=" + idAttachment,
                }).done(function(response) {
                    $('.toastLoading').fadeOut(500, function() {
                        $('.toastLoading').remove();
                    });

                    console.log(response.data);

                    if (response.success) {
                        var copyright = $('#copyright', $modalCopyright).val(response.data);

                        // Open the modal window
                        $modalCopyright.modal('open');
                        M.updateTextFields();
                    }

                    self.lockAjaxForm = false;
                }).fail(function(jqXHR, textStatus) {
                    self.lockAjaxForm = false;
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    console.log("Request failed: " + textStatus);
                    $('.toastLoading').remove();
                });
            }
        });

        // Update the copyright for this media
        $('.content-before .btn-confirm', $modalCopyright).on('click', function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modalCopyright).fadeIn();
            $('.content-before .btn-confirm', $modalCopyright).addClass('disabled');
            $('.content-before .modal-action', $modalCopyright).addClass('disabled');

            var form = $('form', $modalCopyright);
            var ajaxAction = 'dashboard.media.update_copyright';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&idPost=" + idPost + "&idAttachment=" + idAttachment,
            }).done(function(response) {
                $('.preloader-wrapper', $modalCopyright).hide();

                if (response.success) {
                    // Reset the modal window
                    $('.content-before .btn-confirm', $modalCopyright).removeClass('disabled');
                    $('.content-before .modal-action', $modalCopyright).removeClass('disabled');
                    $('#copyright', form).val('');

                    $modalCopyright.modal('close');
                    M.toast({html:'<span>'+ comedien.i18n.optionsSaved +'</span>'}, 5000);
                } else {
                    $('#copyright', form).addClass('invalid');
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                $('.content-before .btn-confirm', $modalCopyright).removeClass('disabled');
                $('.content-before .modal-action', $modalCopyright).removeClass('disabled');

                self.lockAjaxForm = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
                $modalCopyright.modal('close');
            });
        });
    },
};

module.exports = new FrontDashboardFormImages();
